export enum ClaimPackageLocation {
    SHIPPER = 'shipper',
    DESTINATION = 'destination',
    UNKNOWN = 'unknown'
}
